module.exports = __webpack_public_path__ + "img/concept_jp.f8588528.png";